interface RequestParam {
  url;
  method: 'POST' | 'GET';
  data?: Object;
  headers?: Object;
  /** 是否携带经纬度, */
  location?: boolean;
  /** 是否携带用户设备指纹 */
  fingerprint?: boolean;
}

export interface Response<T> {
  error?: Object;
  data: {
    msg: string;
    code: number;
    data: T;
  };
}

/**
 * 默认域名:
 * 线上:fooddelivery.mykeeta.com/api
 * 线下:fooddelivery.mykeeta.test.sankuai.com/api
 * 文档:https://km.sankuai.com/collabpage/1503167496
*/

/**
 * 参数:RequestParam
 *
 * 功能总览
 * 请求:
 * - 默认请求类型为json
 * -  TODO: 环境变量中有泳道时,默认在headers中添加泳道信息
 * - location: 自动携带经纬度信息
 *
 * 响应:
 * 1. 出错或错误码不为0时,默认上报raptor
 *
 * */
function request<T>(arg: RequestParam): Promise<T> {
  const networkModule = Mach.requireModule('Network');
  return new Promise(
    (resolve: (value: T) => void, reject: (error: {
      code: number;
      msg: string;
    }) => void) => {
      const requestParam = {
        url: arg.url,
        method: arg.method,
        data: { ...(arg.location ? getLatLng() : {}), ...(arg.data || {}) },
        dataType: 'json',
        headers: { ...(arg.url || {}) },
      };

      const handleResponse = (response: Response<T>) => {
        const error = response?.error;
        const { code, msg, data } = response?.data || {};

        if (error || code !== 0) {
          const errorInfo = {
            code, msg, error, data
          };
          // Raptor文档:https://km.sankuai.com/page/1303945698;  默认不上报经纬度
          Mach.requireModule('Raptor').reportBusinessException(arg.url, JSON.stringify({ arg, errorInfo }), { type: 'normal' });
          reject(errorInfo);
          return;
        }
        resolve(data);
      };
      // NOTE: 单独获取networkModule.request 时,为undefined,原因未知
      arg.fingerprint
        ? networkModule.requestWx(requestParam, handleResponse)
        : networkModule.request(requestParam, handleResponse);
    },
  );
}

// 获取经纬度
export function getLatLng() {
  const SLLocation = Mach.requireModule('SLLocation');
  const location = SLLocation?.getLocation() || {};
  return {
    latitude: location?.latitude,
    longitude: location?.longitude,
    actualLatitude: location?.actualLatitude,
    actualLongitude: location?.actualLongitude,
  };
}

export default request;
